/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from } from "rxjs"
import { catchError, mergeMap } from "rxjs/operators"
import CONSTANTS from "../../assets/js/Constants"

/* const ThemMoiPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.POST_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			//arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data.data))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)
*/

const SearchLopxe = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.SEARCH_BYTIME),
	mergeMap((action) => {
		const api = async () => {
			const searchLopxe = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TIRE.POST_REPORT_BYTIME, action.payload)
			
			const arrayAction = []

			if (action.payload.view_by == 1){
				arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_BYTIME_BYTIRE, searchLopxe.data.data))

			} else if (action.payload.view_by == 2){
				arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_BYTIME_BYVEHICLE, searchLopxe.data.data))
			} else{
				arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_BYTIME, searchLopxe.data.data))
			}

            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const ThemLopxe = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.POST_PT_TIRE),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			const postLopxe = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TIRE.POST_PT_TIRE, action.payload.data)

			postLopxe.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, postLopxe.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, postLopxe.data.mess))
			
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SEARCH_BYTIME, action.payload.data_search))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const CapNhatLopxe = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.PUT_PT_TIRE),
	mergeMap((action) => {
		const api = async () => {

			const arrayAction = []
			
			const updateLopxe = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TIRE.PUT_PT_TIRE, action.payload.data)		
			
		
			updateLopxe.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateLopxe.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateLopxe.data.mess))
            

			// Reload new list
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SEARCH_BYTIME, action.payload.data_search))


			// Reload new list
			// const dsLopxe = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TIRE.GET_LIST_PHUTUNG)			
			// arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_PHUTUNG, dsLopxe.data.data))
			return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const XoaLopxe = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.DELETE_PT_TIRE),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			let remove_id = (action.payload.id).toString()
			let obj_search = action.payload._search_date
			
			const deleteLopxe = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TIRE.DELETE_PT_TIRE + `id=${remove_id}` )	

			deleteLopxe.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteLopxe.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteLopxe.data.mess))
            
			// Reload new list
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SEARCH_BYTIME, obj_search))
            
			return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const GetListPhuongtien = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.GET_LIST_PHUONGTIEN),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			const dsPhuongtien = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TIRE.GET_LIST_PHUONGTIEN)
				//`${CONSTANTS.URL.TRANSPORTATION.GET_DETAIL_TRANSPORTANTION}?vehicle_id=${action.payload.vehicle_id}`)
			// console.log("🚀 ~ file: tire_epic.js:131 ~ api ~ dsPhuongtien.data:", dsPhuongtien.data)
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_PHUONGTIEN, dsPhuongtien.data.data))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const GetDetailPhuongtien = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.GET_DETAIL_PHUONGTIEN),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			const detailPhuongtien = await CONSTANTS.FUNCTION.AXIOS.GET(
				`${CONSTANTS.URL.TRANSPORTATION.GET_DETAIL_TRANSPORTANTION}?vehicle_id=${action.payload.vehicle_id}`)
			/*detailPhuongtien.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, detailPhuongtien.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, detailPhuongtien.data.mess))
			*/
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_DETAIL_PHUONGTIEN, detailPhuongtien.data.data))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const GetListPhutung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.TIRE.GET_LIST_PHUTUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			const dsPhutung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TIRE.GET_LIST_PHUTUNG)
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_PHUTUNG, dsPhutung.data.data))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

export default {	// manual append to store.js
	SearchLopxe,
	ThemLopxe,
	CapNhatLopxe,
	XoaLopxe,
	GetListPhuongtien,
	GetDetailPhuongtien,
	GetListPhutung
}
